module.exports = __webpack_public_path__ + "media/images/math_wide_main-47e12ff979a2b2d0dadaa3dc04212800.png";